import { Serializable } from '@/models/core/serializable';

export class EventProgress implements Serializable<EventProgress> {
  studentNumber: number; // 生徒 ログインID
  studentName: string = ''; // 生徒氏名
  beforeSurveyCompleted: boolean = false; // イベント前アンケート完了
  beforeSurveyCompletedAt: Date; // イベント前アンケート完了日時
  afterSurveyCompleted: boolean = false; // イベント後アンケート完了
  afterSurveyCompletedAt: Date; // イベント後アンケート完了日時
  q1Answer: string = '';
  q2Answer: string = '';
  q3Answer: string = '';
  grade: number;
  schoolClassName: string = '';

  deserialize(input: any): EventProgress {
    this.studentNumber = input.studentNumber;
    this.studentName = input.studentName;
    if (input.beforeSurveyCompletedAt) {
      this.beforeSurveyCompleted = true;
      this.beforeSurveyCompletedAt = new Date(input.beforeSurveyCompletedAt);
    }
    if (input.afterSurveyCompletedAt) {
      this.afterSurveyCompleted = true;
      this.afterSurveyCompletedAt = new Date(input.afterSurveyCompletedAt);
    }
    this.q1Answer = input.q1Answer;
    this.q2Answer = input.q2Answer;
    this.q3Answer = input.q3Answer;
    this.grade = input.grade;
    this.schoolClassName = input.schoolClassName;

    return this;
  }
}

export class EventProgressResult implements Serializable<EventProgressResult> {
  userSurveyProgress: EventProgress[];
  noAssignedExamineeCount: number;

  deserialize(input: any): EventProgressResult {
    this.userSurveyProgress = input.userSurveyProgress.map((ep: EventProgress) => new EventProgress().deserialize(ep));
    this.noAssignedExamineeCount = input.noAssignedExamineeCount;

    return this;
  }
}
